import "./Class2AHub.module.css";
import ClassroomHeader from "@/reusable_sections/Header";
import WelcomeToOurHive from "./sections/WelcomeToOurHive";
import TheCreativeCorner from "./sections/TheCreativeCorner";
import OurDailyRhythm from "./sections/OurDailyRhythm";
import AdventureAwaits from "./sections/AdventureAwaits";
import ClassroomNews from "./sections/ClassroomNews";
import SayHello from "./sections/SayHello";
import ClassroomFooter from "@/reusable_sections/Footer";
export default function Class2AHubPage() {
  return <div>
      <ClassroomHeader />
      <WelcomeToOurHive />
      <TheCreativeCorner />
      <OurDailyRhythm />
      <AdventureAwaits />
      <ClassroomNews />
      <SayHello />
      <ClassroomFooter />
    </div>;
}